module.exports = __webpack_public_path__ + "img/pd-img-body5.f05ef914.png";